import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './binkiesCompliments.css';
import Spinner from 'react-bootstrap/Spinner';
import { myRoomViewModel } from '../views/my_room/my.room.viewmodel';
import { Chip, Stack } from '@mui/material';
import thetree from '../../assets/images/thetree.svg';
import StarIcon from '../../assets/icon/Creations.svg';
import PlusIcon from '../../assets/icon/plus.svg';
import MinusIcon from '../../assets/icon/minus.svg';
import { Col, Image, Row } from 'react-bootstrap';
import ChallengesInProgress from './ChallengesInProgress';
import IIcon from '../../assets/icon/PRINT.svg';
import { useAuth } from '../auth/Auth';
import DemoTree from '../../assets/tree/demoTree/demo-tree.png';
import {
  DEPENDENT_TREE_ROUTE,
  GUEST_TALETREE,
} from '../../constants/routes.constants';
import { useHistory } from 'react-router-dom';
import { nextChallengeViewModel } from '../views/next_challenge/next.challenge.viewmodel';
import { useHandleMultiLogin } from '../../utils/multilogin';
import GuardianTaleTree from '../views/my_room/kids-room/GuardianTaleTree';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    boxShadow: 'none',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: 8,
    boxShadow: 'none',
  },
  avatar: {
    marginRight: theme.spacing(2),
    cursor: 'pointer',
  },
  content: {
    flex: '1 0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: '15px 22px',
    background: '#321B6D',
    borderRadius: '18px 18px 0px 0px',
  },
  icon: {
    marginRight: '21px',
    cursor: 'pointer',
  },
  PlusIcon: {
    cursor: 'pointer',
  },
}));

const KidInterests = ({
  dependent,
  cardClass,
  showDetailedInsights,
  setShowDetailedInsights,
}) => {
  const classes = useStyles();
  const [compliments, setCompliments] = useState([]);
  const [loading, setLoading] = useState(true);
  const { school } = useAuth();

  const getComplimentsReceived = () => {
    setCompliments([]); // Clear the state before fetching new data
    myRoomViewModel
      .getCreatorInterests(dependent?.username)
      .then((res) => {
        setCompliments(
          res.map((item, i) => {
            const colorIndex = i % 10;
            item.colorIndex = colorIndex;
            return item;
          })
        );
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    setCompliments([]);
    getComplimentsReceived();
  }, [dependent]);

  const handlePlusClick = () => {
    setShowDetailedInsights(!showDetailedInsights);
  };
  const history = useHistory();
  const { handleChildLogin } = useHandleMultiLogin();

  const handleTreeClick = () => {
    console.log(' WORKING TALETREE CLICK');
    // if (dependent?.username) {
    //   handleChildLogin(dependent.id, GUEST_TALETREE);
    //   // history.push(`${DEPENDENT_TREE_ROUTE}/${dependent?.username}`);
    // } else {
    // }
    localStorage.setItem("dependentDetails", JSON.stringify(dependent))
    localStorage.setItem('set_dependent', dependent?.username)
    localStorage.setItem('set_dependent_id', dependent?.id)
    history.push({ pathname: `${DEPENDENT_TREE_ROUTE}/${dependent?.username}`});
    // history.push(`/${dependent?.username}`);
  };
  return loading ? (
    <Spinner
      key={0}
      className="home-feed-spinner"
      animation="border"
      variant="info"
    />
  ) : (
    <Box className={`${classes.root} ${cardClass}`}>
      <Box className={classes.header}>
        <Typography variant="h6" className="compliments-received">
          <img src={thetree} className={classes.icon} alt="Compliment Icon" />
          <span className="tree-span-creativity">
            {dependent?.username}'s TaleTree{' '}
            <span style={{ fontSize: '16px', paddingLeft: '15px' }}>
              (The story of {dependent?.username}'s Creativity)
            </span>
          </span>
        </Typography>
        <img
          src={showDetailedInsights ? MinusIcon : PlusIcon}
          className={classes.PlusIcon}
          alt="Compliment Icon"
          onClick={handlePlusClick}
        />
      </Box>
      <Row className="kids-taletree-insights">
        <Col className='col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12'>
          <Typography
            variant="h6"
            className="compliments-received progress-heading"
          >
            <img src={StarIcon} className={classes.icon} alt="Interest Icon" />
            Interest branches and latest creations
            <img src={PlusIcon} className={classes.icon} alt="Interest Icon" />
          </Typography>
          {compliments.length > 0 ? (
            <Stack
              className="interests-branch kid-interests-branch"
              direction="row"
              spacing={2}
              flexWrap="wrap"
            >
              <Box
                sx={{ cursor: 'pointer' }}
                className="simple-tree-view"
                onClick={() => handleTreeClick()}
              >
                {/* <Box
                  component="img"
                  src={DemoTree}
                  alt="Simple Tree"
                  sx={{
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                  className="simple-tree-image"
                /> */}
                <GuardianTaleTree
                  branchesList={compliments}
                  isMyRoom={false}
                  showAddButtons={false}
                  kidsData={dependent}
                />
              </Box>
            </Stack>
          ) : (
            <div className="insights-text no-data-found">
              <div className="text-wrapper">
                <Image src={IIcon} alt="no-data" />
                <Typography variant="body1">
                  {dependent?.username} hasn’t selected any interest branches or
                  made any creations.
                </Typography>
              </div>
            </div>
          )}
        </Col>
        <Col id="guardian-step-seven" className='col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 mt-xl-0 mt-lg-4 mt-4'>
          <ChallengesInProgress
            type="Received"
            cardClass={'short_second_card'}
            dependent={dependent}
          />
        </Col>
      </Row>
    </Box>
  );
};

export default KidInterests;
